import * as React from "react"

interface InputWrapperProps {
  children: React.ReactNode
  name: string,
  description?: string,
  error?: string
}

function InputWrapper({ children, ...props }: InputWrapperProps) {
  return (
    <div className="flex flex-col gap-1">
    <label>{props.name}</label>
    {props.description ? (
      <label className="text-gray-600">{props.description}</label>
    ) : null}
    <div className="flex gap-1">
        {children}
    </div>
    {props.error ? (
      <span className="text-red-500">{props.error}</span>
    ) : null}
    </div>
  )
}

export { InputWrapper }
